import React from "react";
import { Collapsible, CollapsibleTrigger, CollapsibleContent } from "../ui/Collapsible";
import { INSPECTOR_SECTION_TITLE_TO_BODY_PAD_CLASS } from "../../utils/inspectorChromeButtonClasses";

/**
 * Collapsible visibility block for inspector panels — trigger styling matches other {@link CollapsibleTrigger} sections.
 */
export const InspectorVisibilitySection = React.memo(function InspectorVisibilitySection({
  sectionTitle,
  /** Radix collapsible initial state; default stays open for inspector toolbars unless overridden. */
  defaultOpen = true,
  /** Optional classes for the primary title span (e.g. muted treatment for Asset Library vs. inspector sections). */
  sectionTitleClassName = "",
  /** Muted inline text beside the section title (e.g. `(6/10)`). */
  sectionTitleTrailing = null,
  /** Optional classes for trailing text (counts, badges). Defaults to inspector panel type-chip styling. */
  sectionTitleTrailingClassName = "text-[10px] font-bold uppercase tracking-wide tabular-nums text-gray-400",
  headerActions,
  children,
  className = "",
}) {
  return (
    <div className={className}>
      <Collapsible defaultOpen={defaultOpen}>
        <CollapsibleTrigger
          quiet
          actions={headerActions}
          actionsClassName="gap-1"
          aria-label={`Toggle ${sectionTitle}`}
        >
          <>
            <span className={`min-w-0 truncate text-left ${sectionTitleClassName}`.trim()}>
              {sectionTitle}
            </span>
            {sectionTitleTrailing ? (
              <span className={`shrink-0 ${sectionTitleTrailingClassName}`.trim()}>
                {sectionTitleTrailing}
              </span>
            ) : null}
          </>
        </CollapsibleTrigger>
        <CollapsibleContent>
          <div className={`space-y-2 ${INSPECTOR_SECTION_TITLE_TO_BODY_PAD_CLASS}`}>{children}</div>
        </CollapsibleContent>
      </Collapsible>
    </div>
  );
});
